import theme from '@/style';
import React from 'react';
import {BALLS} from '../constant';

export interface BallProps {
  digit: string;
  disabled?: boolean;
  ballSize?: number;
  fontSize?: number;
  color?: string;
  onlyColor: boolean;
  fontColor?: string;
  onPress?: () => void;
  isSmall?: boolean;
}

const Ball = ({
  ballSize = 56,
  digit = '0',
  disabled = false,
  color,
  onlyColor = false,
  fontColor,
  fontSize = 24,
  isSmall,
  onPress,
}: BallProps) => {
  const bg = React.useMemo(() => {
    if (onlyColor) {
      if (color === 'g') {
        return BALLS.green;
      }
      if (color === 'v') {
        return BALLS.violet;
      }
      if (color === 'r') {
        return BALLS.red;
      }
    } else {
      if (color === 'g') {
        return disabled ? BALLS.greenDisabled : BALLS.green;
      }
      if (color === 'r') {
        return disabled ? BALLS.redDisabled : BALLS.red;
      }
      if (color === 'g,v') {
        return disabled ? BALLS.greenVDisabled : BALLS.greenV;
      }
      if (color === 'r,v') {
        return disabled ? BALLS.redVDisabled : BALLS.redV;
      }
      if (color === '*') {
        return BALLS.colorNone;
      }
    }
  }, [disabled, color, onlyColor]);

  const num = React.useMemo(() => {
    if (onlyColor) {
      const text = digit === 'g' ? 'GREEN' : digit === 'r' ? 'RED' : 'VIOLET';
      return isSmall ? text[0] : text;
    } else {
      return digit;
    }
  }, [onlyColor, digit, isSmall]);

  const textColor =
    fontColor || (onlyColor ? theme.basicColor.white : theme.basicColor.dark);

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onPress && onPress()}
      className="flex shrink-0 items-center justify-center border-0 bg-transparent p-0 outline-none disabled:cursor-not-allowed"
      style={{
        width: ballSize,
        height: ballSize,
        cursor: onPress && !disabled ? 'pointer' : 'default',
      }}>
      <span
        className="flex h-full w-full items-center justify-center bg-contain bg-center bg-no-repeat text-center font-bold"
        style={{
          backgroundImage: bg ? `url(${bg})` : undefined,
          color: textColor,
          fontSize,
          fontFamily: 'Inter, sans-serif',
          lineHeight: 1,
        }}>
        {num}
      </span>
    </button>
  );
};

export default Ball;
